export enum FiUserContactTypeEnum {
    Email,
    PhoneNumber,
}
